import { configureStore, StoreEnhancer } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { reduxBatch } from '@manaflair/redux-batch';
import { persistStore } from 'redux-persist';
import { rootReducer } from './RootReducer';

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// Explicitly type the enhancers array
const enhancers: StoreEnhancer[] = [reduxBatch as StoreEnhancer];  // Typecast reduxBatch to StoreEnhancer

// Create and configure the Redux store
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
      thunk: true,  // This is the default, so it could be omitted if not needed
    }).concat(sagaMiddleware),  // Add the saga middleware to the default middleware stack
  devTools: process.env.NODE_ENV !== 'production', // Enable devtools in non-production environments
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(enhancers),  // Use batch enhancer for better performance with many dispatches
});

// Define AppDispatch type for dispatch type-safety
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);

// sagaMiddleware can be run like this (currently commented out as the saga is not yet defined):
// sagaMiddleware.run(rootSaga);

export default store;
